import * as React from "react"

import { cn } from "@/lib/utils"

/**
 * Input — UI Foundation Phase 1 (design.md §Inputs: compact radius, coloured
 * focus ring). Height comes from `--control-h-sm` so the Admin Console keeps
 * its denser controls inside `.legacy-admin-scope`.
 */
const Input = React.forwardRef(({ className, type, ...props }, ref) => {
  return (
    <input
      type={type}
      className={cn(
        "flex h-[var(--control-h-field)] w-full rounded-md border border-input bg-surface px-3 py-1 text-sm text-content",
        "shadow-sm transition-[border-color,box-shadow] duration-base ease-system",
        "file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-content",
        "placeholder:text-content-muted",
        "focus-visible:outline-none focus-visible:border-focus focus-visible:ring-2 focus-visible:ring-focus/30",
        "disabled:cursor-not-allowed disabled:opacity-60",
        className
      )}
      ref={ref}
      {...props} />
  );
})
Input.displayName = "Input"

export { Input }
